const enum ProductButtonType {
  QTY_STEPPER = 'QTY_STEPPER',
  PROMOTION_CARD = 'PROMOTION_CARD',
}

export { ProductButtonType };
